export default __webpack_public_path__ + "static/media/plain-sticker-b.3d48128a.png";